import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'

export interface AnnouncementProps {
  title: string
  content: string
  setShowAnnouncementBox: React.Dispatch<React.SetStateAction<boolean>>
}

export const useAnnouncement = (props: AnnouncementProps) => {
  const boxBgColor: string | undefined = useSelector(
    (state: RootState) =>
      state.restaurantInfo.restaurantInfo?.colors.popupBackground
  )
  const boxTitleColor: string | undefined = useSelector(
    (state: RootState) => state.restaurantInfo.restaurantInfo?.colors.popupTitle
  )

  return {
    ...props,
    boxBgColor,
    boxTitleColor,
  }
}
